import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { createClient } from "@supabase/supabase-js";
const apiBase = process.env.REACT_APP_API_URL;
const supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_KEY);

export default function TrainingTimer({ playerId, leagueId, trainingEndsAt, onCompleted }) {
  const [remaining, setRemaining] = useState(Math.max(new Date(trainingEndsAt).getTime() - Date.now(), 0));
  const [loading, setLoading] = useState(false);

  const intervalRef = useRef(null);

  // ⏱Countdown timer
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const diff = new Date(trainingEndsAt).getTime() - Date.now();
      setRemaining(Math.max(diff, 0));
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [trainingEndsAt]);

  // Display
  const hrs = Math.floor(remaining / 3600000);
  const mins = Math.floor((remaining % 3600000) / 60000);
  const secs = Math.floor((remaining % 60000) / 1000);

  // Collect (server-authoritative)
  const handleCollect = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      await axios.post(`${apiBase}/api/region/train/complete/${leagueId}`, { playerId }, { headers: { Authorization: `Bearer ${token}` } });

      toast.success("Training collected!");
      onCompleted?.();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to collect training");
    } finally {
      setLoading(false);
    }
  };

  // Instant Finish
  const handleInstantTrain = async () => {
    if (!window.confirm("Spend 1 coin to instantly finish training?")) return;
    setLoading(true);

    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      await axios.post(
        `${apiBase}/api/region/train/accelerate/${leagueId}`,
        { playerId, type: "instant" },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Training completed instantly!");
      onCompleted?.();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to finish instantly");
    } finally {
      setLoading(false);
    }
  };

  // Finished state (NO auto fire)
  if (remaining === 0) {
    return (
      <div className="training-status">
        <h4>Training Complete!</h4>
        <button className="train-now" onClick={handleCollect} disabled={loading}>
          Collect
        </button>
      </div>
    );
  }

  return (
    <div className="training-status">
      <p style={{ letterSpacing: "-0.4px", margin:"0", opacity: "0.6" }}>Training finishes in:</p>
      <h2>
        {String(hrs).padStart(2, "0")}h {String(mins).padStart(2, "0")}m {String(secs).padStart(2, "0")}s
      </h2>

      <div className="actions">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p style={{ margin: "0 0 10px 0" }}>
            <b>Train Instantly</b>
          </p>
          <button className="train-now" onClick={handleInstantTrain} disabled={loading}>
            <img src="/xp-boost.png" style={{ width: "28px" }} alt="XP Boost" />1
          </button>
        </div>
      </div>
    </div>
  );
}
